module.exports = __webpack_public_path__ + "img/icon_basket.671ae334.svg";